// extracted by mini-css-extract-plugin
module.exports = {"menuRightSocialLink":"navigator_menuRightSocialLink__2yENT","menuTopSocialLink":"navigator_menuTopSocialLink__1taV4"};